import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import { HomeComponent } from './home/home.component';
import { TopoComponent } from './topo/topo.component';
import { NomeSistemaComponent } from './nome-sistema/nome-sistema.component';
import { RodapeComponent } from './rodape/rodape.component';
import { AcessoNegadoComponent } from './acesso-negado/acesso-negado.component';
import { AcessoNegadoGenericoComponent } from './acesso-negado-generico/acesso-negado-generico.component';
import { AcessoSemRegistroComponent } from './acesso-sem-registro/acesso-sem-registro.component';
import { AcessoSemServicoComponent } from './acesso-sem-servico/acesso-sem-servico.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpUtilService } from './services/http-util.service';
import { ApplicationErrorHandler } from './app.error-handler';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatButtonModule, MatCheckboxModule, MatListModule,
  MatCardModule, MatRadioModule, MatSidenavModule, MatAutocompleteModule, MatInputModule, MatSelectModule,
  MatDatepickerModule, MatNativeDateModule, MatMenuModule, MatPaginatorModule, MatTableModule, MatExpansionModule,
  MatSnackBarModule, MatProgressSpinnerModule, MatStepperModule, MatTooltipModule, MatIconModule } from '@angular/material';
import {Ng2BRPipesModule} from 'ng2-brpipes';
import { NgBrazil } from 'ng-brazil';
import { NgxMaskModule } from 'ngx-mask';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MenuComponent } from './menu/menu.component';
import { CadastraMaquinaComponent } from './cadastra-maquina/cadastra-maquina.component';
import { ConsultaMaquinaComponent } from './consulta-maquina/consulta-maquina.component';
import { TrocarOutorgaComponent } from './trocar-outorga/trocar-outorga.component';
import { ModalAjudaAtivacaoKriptonitaComponent } from './modal-ajuda-ativacao-kriptonita/modal-ajuda-ativacao-kriptonita.component';
import { MessageService } from './services/message.service';

import { ModalTermoComponent } from './modal-termo/modal-termo.component';
import { HistoricoMaquinaComponent } from './consulta-maquina/historico-maquina/historico-maquina.component';
import { AlteraEstadoMaquinaComponent } from './altera-estado-maquina/altera-estado-maquina.component';
import { ModalRecuperaTokenUsuarioComponent } from './modal-recupera-token-usuario/modal-recupera-token-usuario.component';
import { ModalSalvaTokenUsuarioComponent } from './modal-salva-token-usuario/modal-salva-token-usuario.component';
import { AlteraMaquinaComponent } from './altera-maquina/altera-maquina.component';
import {MatProgressBarModule} from '@angular/material';
import { TermoAceiteComponent } from './termo-aceite/termo-aceite.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { LoadService } from './services/load.service';
import { LoaderInterceptorService } from './interceptors/loader-interceptor.service';
import { SistemaCarregandoComponent } from './sistema-carregando/sistema-carregando.component';
import { AcessoSemServicoNodeComponent } from './acesso-sem-servico-node/acesso-sem-servico-node.component';
import { BotaoAjudaComponent } from './botao-ajuda/botao-ajuda.component';
import { ModalCryptoComponent } from './modal-Crypto/modal-crypto.component';

@NgModule({
  declarations: [
    AppComponent,
    GenericModalComponent,
    ModalAjudaAtivacaoKriptonitaComponent,
    HomeComponent,
    TopoComponent,
    NomeSistemaComponent,
    RodapeComponent,
    AcessoNegadoComponent,
    AcessoNegadoGenericoComponent,
    AcessoSemRegistroComponent,
    AcessoSemServicoComponent,
    MenuComponent,
    CadastraMaquinaComponent,
    ConsultaMaquinaComponent,
    TrocarOutorgaComponent,
    ModalTermoComponent, 
    HistoricoMaquinaComponent,   
    AlteraEstadoMaquinaComponent,
    ModalRecuperaTokenUsuarioComponent,
    ModalSalvaTokenUsuarioComponent,
    AlteraMaquinaComponent,
    TermoAceiteComponent,
    SistemaCarregandoComponent,
    AcessoSemServicoNodeComponent,
    BotaoAjudaComponent,
    ModalCryptoComponent

    
  ],
  entryComponents: [GenericModalComponent, ModalCryptoComponent, TrocarOutorgaComponent, ModalAjudaAtivacaoKriptonitaComponent,
    ModalTermoComponent, ModalSalvaTokenUsuarioComponent, ModalRecuperaTokenUsuarioComponent ],
    
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatDialogModule,
    NgxMaskModule.forRoot(),
    NgBrazil,
    TextMaskModule,
    Ng2BRPipesModule,
    BrowserModule,
    MatButtonModule,
    MatCheckboxModule,
    AppRoutingModule,
    NgxMaskModule.forRoot(),
    MatListModule,
    MatCardModule,
    MatRadioModule,
    MatSidenavModule,
    MatAutocompleteModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatPaginatorModule,
    MatTableModule,
    MatExpansionModule,
    MatSnackBarModule,
    NoopAnimationsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatStepperModule,
    MatProgressBarModule
   
  ],
  providers: [
    HttpUtilService,
    MessageService,
   { provide: ErrorHandler, useClass: ApplicationErrorHandler },
    { provide: LOCALE_ID, useValue: 'pt-PT'},
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    {provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true }},
    LoadService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
